const {
  REACT_APP_FEATURE_TRACES_SCANNING_WARRANTS = false,
  REACT_APP_FEATURE_DELETE_ORDER = false,
  REACT_APP_FEATURE_REMOVE_SCAN_PAGE_VALIDATION = false,
} = process.env
const features = {
  traces_scanning_warrants: REACT_APP_FEATURE_TRACES_SCANNING_WARRANTS === 'true',
  delete_order: REACT_APP_FEATURE_DELETE_ORDER === 'true',
  remove_scan_page_validation: REACT_APP_FEATURE_REMOVE_SCAN_PAGE_VALIDATION === 'true',
}

export default features
